export const GET_PDF_LOADING = 'pdf/GET_PDF_ACTA_INICIO_LOADING';
export const GET_PDF_SUCCESS = 'pdf/GET_PDF_ACTA_INICIO_SUCCES';
export const GET_PDF_FAILURE = 'pdf/GET_PDF_ACTA_INICIO_FAILURE';
